import { useCallback } from 'react';

import useBrainSession from '@/services/BrainSession/useBrainSession.ts';

export const useStartRefinFlow = () => {
  const { toggleChat } = useBrainSession();

  return useCallback(() => {
    toggleChat({
      goal: 'debt_check',
      step: 'skip_start',
    });
  }, [toggleChat]);
};
